import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import SectionHeader from '../SectionHeader/SectionHeader';
import Checkmark from 'src/svgs/commerce/checkmark.svg';
import { headerWithDescType } from 'src/types';
import { classNames } from 'src/utils/helpers';

function PackageTiers({ tiers, sectionHeader: { title, tagline, description } }) {
  return (
    <Container fluid as="section" className="py-5">
      <SectionHeader title={title} tagline={tagline} description={description} />

      <Container className="mt-4">
        <Row>
          <Col xs={12}>
            <Row className="justify-content-center">
              {tiers?.map((tier) => (
                <Col key={tier.id} xs={12} sm={10} md={6} xl={4} className="py-3">
                  <Row
                    noGutters
                    className={classNames('flex-column h-100 px-4 py-6', {
                      'bg-gray-750 text-white': tier.isDark,
                      'bg-white': !tier.isDark,
                    })}
                    style={{
                      borderRadius: 20,
                      boxShadow: '4px 32px 64px rgba(71, 85, 137, 0.24)',
                    }}
                  >
                    <Col xs="auto" className="rfs-size-sm font-weight-black text-uppercase text-center">
                      {tier.tagline}
                    </Col>
                    <Col xs="auto" className="rfs-size-2xl font-weight-black mt-2 text-center">
                      {tier.title}
                    </Col>
                    <Col xs="auto" className="mb-6 mt-5">
                      {tier.features.map((feature) => (
                        <Col key={feature} className="mt-3">
                          <Row className="align-items-center flex-nowrap">
                            <Col xs="auto">
                              <Checkmark />
                            </Col>
                            <Col className="rfs-size-sm pt-1" style={tier.isDark ? { color: 'rgba(255, 255, 255, 0.72)' } : null}>
                              {feature}
                            </Col>
                          </Row>
                        </Col>
                      ))}
                    </Col>
                    {tier.link && (
                      <Col xs="auto" className="mt-auto text-center">
                        <Link
                          key={tier.link._key}
                          to={tier.link.url}
                          className={classNames('btn btn-block ', {
                            'btn-gradient-secondary': tier.isDark,
                            'btn-gradient-primary': !tier.isDark,
                          })}
                        >
                          {tier.link.title}
                        </Link>
                      </Col>
                    )}
                  </Row>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

PackageTiers.propTypes = {
  tiers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      tagline: PropTypes.string,
      isDark: PropTypes.bool,
      features: PropTypes.arrayOf(PropTypes.string),
      link: PropTypes.shape({}),
    })
  ).isRequired,
  sectionHeader: headerWithDescType.propTypes,
};

PackageTiers.defaultProps = {
  sectionHeader: headerWithDescType.defaultProps,
};

export default PackageTiers;
